import { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { NexaBootSplash } from '@/components/nexa-mark/nexa-boot-splash';
import { takeReturnTo } from '@/auth/return-to';

// Per docs/ui/auth0-frontend-tds.md §5.2 — stub route that resolves the SDK's
// redirect handshake and navigates onward. auth0-react's internal handler runs
// on mount; we only wait and navigate.

export function CallbackPage() {
  const { isAuthenticated, isLoading, error } = useAuth0();
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      // Honour the path the shell was asked for before it demanded a login.
      // This used to be a hardcoded '/', which is why deep links (a shared
      // case, /contracts/new) all resolved to the dashboard.
      navigate(takeReturnTo() ?? '/', { replace: true });
    }
  }, [isLoading, isAuthenticated, navigate]);

  if (error) {
    return (
      <div className="flex h-screen items-center justify-center px-6">
        <div className="max-w-md text-center">
          <h1 className="text-xl font-semibold">{t('admin:auth.signInFailed')}</h1>
          <p className="mt-3 text-sm text-destructive">{error.message}</p>
        </div>
      </div>
    );
  }

  return <NexaBootSplash label={t('nexa.signingIn')} />;
}
